module.exports = __webpack_public_path__ + "static/media/Anthony_Kava.8f99b08c.jpg";